/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

/**
 * Loading Splash Screen Component
 *
 * Full-screen loading overlay with logo and animated loader.
 * Used for initial app loading or major transitions.
 * Custom CSS-based ScaleLoader animation for better performance.
 */

import React from "react";
import "./loadingSplash.css";

const LOADER_BARS = [0, 1, 2, 3, 4] as const;

interface LoadingSplashProps {
  logoSrc?: string;
  logoAlt?: string;
}

const LoadingSplash: React.FC<LoadingSplashProps> = ({
  logoSrc = "/images/deskshare_logo.png",
  logoAlt = "Logo",
}) => {
  return (
    <div className="loading-splash-overlay">
      <div className="loading-splash-content">
        <div>
          <img src={logoSrc} alt={logoAlt} loading="eager" />
        </div>
        <div className="loading-splash-bars">
          {LOADER_BARS.map((index) => (
            <div
              key={index}
              className="loading-splash-bar"
              // Dynamic stagger via CSS custom property — avoids a static
              // CSS class per bar index while keeping inline styles minimal.
              style={{ "--bar-delay": `${index * 0.1}s` } as React.CSSProperties}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingSplash;
